
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lNp1U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0f40f56d7c5dc079$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $0f40f56d7c5dc079$export$2e2bcd8739ae039 = {
    'fabric.atlassianSwitcher.administration': 'Beheer',
    'fabric.atlassianSwitcher.analytics': 'Analyses',
    'fabric.atlassianSwitcher.assets': 'Assets',
    'fabric.atlassianSwitcher.atlassianHome': 'Startpagina',
    'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Probeer Atlassian-producten',
    'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': 'Samenwerken aan documenten',
    'fabric.atlassianSwitcher.chat': 'Chat',
    'fabric.atlassianSwitcher.companyHub': 'Bedrijfshub',
    'fabric.atlassianSwitcher.confluenceDescriptionText': 'Documenteer en werk samen',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-space',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.body': 'Probeer een product om samen te werken met je team.',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Ontdek producten',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Ga aan de slag met cloud',
    'fabric.atlassianSwitcher.errorEmptyPartialResults': 'We kunnen je apps nu niet weergeven.',
    'fabric.atlassianSwitcher.errorFlag.description': 'Probeer het over een paar minuten opnieuw. Als je nog steeds niet kunt deelnemen, <a>neem dan contact op met support</a>.',
    'fabric.atlassianSwitcher.errorFlag.title': 'We konden je niet toevoegen aan {product}',
    'fabric.atlassianSwitcher.errorHeading': 'Er is iets misgegaan.',
    'fabric.atlassianSwitcher.errorHeadingLoggedOut': 'Je Atlassian-account is uitgelogd',
    'fabric.atlassianSwitcher.errorHeadingUnverified': 'Je account is niet geverifieerd',
    'fabric.atlassianSwitcher.errorImageAltText': 'Een defecte robot en een aantal mensen die bezig zijn hem te repareren.',
    'fabric.atlassianSwitcher.errorPartialResults': 'We kunnen sommige van je apps nu niet weergeven.',
    'fabric.atlassianSwitcher.errorPartialResultsRefresh': 'Vernieuw de pagina of probeer het later opnieuw.',
    'fabric.atlassianSwitcher.errorText': 'We houden deze fouten bij, maar aarzel niet om contact met ons op te nemen als pagina vernieuwen het probleem niet oplost.',
    'fabric.atlassianSwitcher.errorTextLoggedOut': 'Log opnieuw in om de Atlassian-switcher te gebruiken.',
    'fabric.atlassianSwitcher.errorTextNetwork': 'De lijst met artikelen kan niet worden geladen. Laad de pagina opnieuw en probeer het nog eens.',
    'fabric.atlassianSwitcher.errorTextUnverified': 'Bevestig je e-mailadres om een lijst met beschikbare producten te bekijken.',
    'fabric.atlassianSwitcher.goals': 'Doelen',
    'fabric.atlassianSwitcher.home': 'Atlassian-startpagina',
    'fabric.atlassianSwitcher.instantAccessStatusText': 'Directe toegang',
    'fabric.atlassianSwitcher.jiraDescriptionText': 'Plan en volg de levering van projecten',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-project',
    'fabric.atlassianSwitcher.join': 'Koppelen',
    'fabric.atlassianSwitcher.joinStatusText': 'Lid worden',
    'fabric.atlassianSwitcher.joinTeamStatusText': 'Aansluiten bij het team',
    'fabric.atlassianSwitcher.jpdDescriptionText': "Stel prioriteiten en plan nieuwe idee\xebn",
    'fabric.atlassianSwitcher.jsmDescriptionText': 'Automatiseer en bied IT-support',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription': 'Projecten beheren voor bedrijfsteams',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription': 'Zakelijke projecten beheren, gratis met Jira Software',
    'fabric.atlassianSwitcher.login': 'Inloggen',
    'fabric.atlassianSwitcher.manageList': 'Lijst beheren',
    'fabric.atlassianSwitcher.modalLabel': 'Atlassian-app-switcher',
    'fabric.atlassianSwitcher.more': 'Meer',
    'fabric.atlassianSwitcher.newLozenge': 'Nieuw',
    'fabric.atlassianSwitcher.organisationsLabel': 'Organisaties',
    'fabric.atlassianSwitcher.product.description.compass': 'Componentbeheerder',
    'fabric.atlassianSwitcher.product.description.confluence': 'Samenwerken aan documenten',
    'fabric.atlassianSwitcher.product.description.jsm': "Co\xf6peratief IT-servicebeheer",
    'fabric.atlassianSwitcher.product.description.jsw': 'Projecten en issues volgen',
    'fabric.atlassianSwitcher.product.description.opsgenie': 'Modern incidentmanagement',
    'fabric.atlassianSwitcher.requestAccessStatusText': 'Toegang aanvragen',
    'fabric.atlassianSwitcher.requestSentStatusText': 'Aanvraag verstuurd',
    'fabric.atlassianSwitcher.resizeBarLabel': "'Uitklappen' of 'Inklappen' afhankelijk van de status",
    'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Sleep om de grootte te wijzigen{separator}Druk om uit te vouwen',
    'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Sleep om de grootte te wijzigen{separator}Druk om in te vouwen',
    'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Breedte',
    'fabric.atlassianSwitcher.search': 'Zoeken',
    'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} site} other {{productName} sites}}',
    'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': 'De App-switcher wordt geladen',
    'fabric.atlassianSwitcher.start': 'Atlassian-startpagina',
    'fabric.atlassianSwitcher.startAriaLabel': 'De Atlassian-startpagina opent in een nieuw tabblad',
    'fabric.atlassianSwitcher.studio': 'Studio',
    'fabric.atlassianSwitcher.successFlag.description': 'Je ontvangt een e-mail als het is goedgekeurd',
    'fabric.atlassianSwitcher.successFlag.title': 'Aanvraag om toegang verstuurd naar de Beheerder',
    'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Wisselen van sites of apps',
    'fabric.atlassianSwitcher.switchTo': 'Overschakelen naar',
    'fabric.atlassianSwitcher.switchToTooltip': 'Overschakelen naar...',
    'fabric.atlassianSwitcher.teams': 'Teams',
    'fabric.atlassianSwitcher.tryLozenge': 'Proberen',
    'fabric.atlassianSwitcher.yourApps': 'Je apps',
    'fabric.atlassianSwitcher.yourAppsTooltip': "Je apps \u2026"
};

});


//# sourceMappingURL=@atlaskit-internal_async-atlassian-switcher-i18n-nl.593c7ced.js.map
